var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2928 8.82285C17.6922 8.76787 18 8.42047 18 8.00011C18 7.54154 17.6337 7.16979 17.1818 7.16979L2.80007 7.16979L7.99531 1.91866L8.07472 1.8257C8.31304 1.50114 8.28757 1.0398 7.9977 0.744412C7.67884 0.419481 7.1608 0.418393 6.84062 0.741981L0.25226 7.40045C0.213041 7.43858 0.177555 7.48063 0.146416 7.52599C-0.0766354 7.85024 -0.0452156 8.30006 0.240669 8.58894L6.84067 15.2581L6.9326 15.3383C7.25342 15.5787 7.7079 15.551 7.99775 15.2555C8.31658 14.9306 8.31546 14.4049 7.99526 14.0813L2.79877 8.83043L17.1818 8.83043L17.2928 8.82285Z",
    fill: "#917AFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow - Left.56b36d0b313c29a7b46527aa85dd3d8e.svg";
export { ForwardRef as ReactComponent };